import React, { useEffect, useRef, useState } from "react";
import { AiOutlineClockCircle, AiOutlineEye } from "react-icons/ai";
import { IoPersonCircleOutline } from "react-icons/io5";
import { FaCaretRight } from "react-icons/fa";
import moment from "moment/moment";
import { Image, ScrollShadow } from "@nextui-org/react";
import Link from "next/link";

export default function YoutubePlaylistEmbed({ data, playlistId }) {
    const [videoData, setVideoData] = useState(null);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const videoRefs = useRef({});

    useEffect(() => {
        if (data) {
            setVideoData(data);
            setSelectedVideo(data[0]);
        }
    }, [data]);

    useEffect(() => {
        if (selectedVideo && videoRefs.current[selectedVideo.videoId]) {
            videoRefs.current[selectedVideo.videoId].scrollIntoView({
                behavior: "smooth",
                block: "nearest",
            });
        }
    }, [selectedVideo]);

    if (!videoData || videoData.items?.length === 0 || !selectedVideo) return null;

    return (
        <div className="relative bg-primary w-full mt-3 p-2 flex flex-col lg:flex-row gap-x-2">
            {/* Video display container */}
            <div className="flex-1 lg:flex-[5] lg:w-[550px] mb-3 lg:mb-0">
                <div className="relative w-full pt-[56.25%] overflow-hidden">
                    <iframe
                        src={`https://www.youtube.com/embed/${selectedVideo?.videoId}?controls=1&modestbranding=1&rel=0&showinfo=0&iv_load_policy=3`}
                        className="absolute top-0 left-0 w-full h-full object-contain"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title={selectedVideo?.title}
                    />
                </div>
                <p className="font-bold text-white mt-2 truncate w-[90%] text-sm">
                    {selectedVideo?.title}
                </p>
                <div className="flex flex-col md:flex-row gap-3 w-fit mt-1.5">
                    <div className="flex items-center gap-0.5">
                        <IoPersonCircleOutline className="font-bold text-[14px] text-white" />
                        <p className="inline-block font-bold text-xs text-white truncate">
                            {selectedVideo?.channelTitle}
                        </p>
                    </div>
                    <div className="flex flex-row items-center gap-3">
                        <div className="flex items-center gap-0.5">
                            <AiOutlineClockCircle className="font-bold text-[14px] text-white" />
                            <p className="font-bold text-xs text-white">
                                {moment(selectedVideo?.publishedAt).format("DD/MM/YYYY")}
                            </p>
                        </div>
                        <div className="flex items-center gap-0.5">
                            <AiOutlineEye className="font-bold text-[14px] text-white" />
                            <p className="font-bold text-xs text-white">{selectedVideo?.views || 0}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Container of video list */}
            <div className="relative flex-1 flex-col lg:flex-[3] w-full h-[300px] lg:h-[350px] xl:h-[380px] overflow-hidden">
                <ScrollShadow hideScrollBar={true} size={10} className="h-[150px] sm:h-[200px] lg:h-[310px] xl:h-[370px] overflow-auto">
                    {videoData.map((video) => (
                        <div
                            key={video.videoId}
                            className="flex items-center justify-start md:py-1 lg:py-2"
                            ref={(el) => (videoRefs.current[video.videoId] = el)}
                        >
                            <div className="flex justify-center items-center w-2">
                                {
                                    selectedVideo.videoId === video.videoId && (
                                        <FaCaretRight className={`text-white text-xl` } />
                                    )
                                }
                            </div>
                            <div
                                onClick={() => setSelectedVideo(video)}
                                className="h-20 md:h-16 w-full flex items-center gap-2 p-1 cursor-pointer hover:bg-[#ffffff11]"
                            >
                                <div className="h-fit w-24 sm:w-28 md:w-28 lg:w-32 flex items-center">
                                    <Image
                                        alt="thumbnail"
                                        src={`${video.thumbnail}`}
                                        className="aspect-[16/9] object-cover rounded-md w-full"
                                    />
                                </div>
                                <div className="flex-1">
                                    <p className="font-bold text-white text-xs line-clamp-2 w-[90%]">
                                        {video.title}
                                    </p>
                                    <div className="flex gap-3 w-full mt-1">
                                        <div className="flex items-center gap-0.5">
                                            <AiOutlineClockCircle className="font-bold text-xs text-white" />
                                            <p className="font-bold text-[10px] text-white mb-[1px]">
                                                {moment(video.publishedAt).format("DD/MM/YYYY")}
                                            </p>
                                        </div>
                                        <div className="flex items-center gap-0.5">
                                            <AiOutlineEye className="font-bold text-[12px] text-white" />
                                            <p className="font-bold text-[10px] text-white mb-[1px]">
                                                {video.views || 0}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </ScrollShadow>
            </div>
            <div className="absolute right-1 bottom-1 flex justify-end items-end md:h-[50px] sm:h-[20px]">
                <Link
                    href={`https://www.youtube.com/playlist?list=${playlistId}`}
                    target="_blank"
                    className="z-10 text-xs lg:text-sm text-white font-bold hover:text-secondary"
                >
                    Xem Thêm...
                </Link>
            </div>
        </div>
    );
}